import React from 'react';
import { motion } from 'framer-motion';
import useSponsors from '../hooks/useSponsors';
import './SponsorWall.css';

function LogoPlate({ sponsor }) {
  const plate = (
    <span className="sponsor-wall-plate">
      <img src={sponsor.logoUrl} alt={sponsor.name} />
    </span>
  );

  if (!sponsor.website) {
    return <div className="sponsor-wall-item">{plate}</div>;
  }

  return (
    <a
      className="sponsor-wall-item"
      href={sponsor.website}
      target="_blank"
      rel="noopener noreferrer"
    >
      {plate}
    </a>
  );
}

export default function SponsorWall() {
  const { sponsors, loading } = useSponsors();

  if (loading || sponsors.length === 0) return null;

  return (
    <section className="sponsor-wall" aria-label="Sponsors">
      <motion.h2
        className="sponsor-wall-title"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        Thank you to our sponsors
      </motion.h2>
      <motion.p
        className="sponsor-wall-lead"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.1 }}
      >
        These local businesses keep our players on the ice. Thank you for backing the Glass City Gladiators.
      </motion.p>
      <div className="sponsor-wall-grid">
        {sponsors.map((sponsor, index) => (
          <motion.div
            className="sponsor-wall-cell"
            key={sponsor.id || sponsor.name}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: Math.min(index, 8) * 0.05 }}
          >
            <LogoPlate sponsor={sponsor} />
          </motion.div>
        ))}
      </div>
    </section>
  );
}
